// @flow

import fetchPRS from './fetchprs';
import { AuthenticationEndpoint } from './config';
import { handleNetworkError } from './ui';
import { updateTermsAndConditionsState } from './tnc';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const CHANGE_PROFILE = 'CHANGE_PROFILE';

const authStart = () => ({ type: AUTH_START });

const authSuccess = data => ({ type: AUTH_SUCCESS, payload: data });

const authFailed = data => ({ type: AUTH_FAILURE, payload: data });

const changeProfileCookie = profileId => ({
  type: CHANGE_PROFILE,
  profileId,
});

function handleSwitchUser(state) {
  const page = window.location.hash.slice(1);
  let lastPage = '';
  if (state.search.searchParamsHistory.length > 0) {
    lastPage = state.search.searchParamsHistory[0].page;
  }
  if (page === '/mywork') {
    window.location = '#/myworks';
  } else if (page === '/possiblematches' && lastPage === '/mywork') {
    window.location = '#/myworks';
  } else if (page === '/possiblematches' && lastPage === '/searchresults') {
    window.location = '#/myworks';
  } else if (page !== '/myworks' && page !== '/') {
    window.location = '#/';
  }
}

export const changeProfile = profileId => (dispatch, getState) => {
  dispatch(authStart());
  dispatch(changeProfileCookie(profileId));
  return fetchPRS(`${AuthenticationEndpoint}?profileId=${profileId}`, dispatch)
    .then(data => dispatch(authSuccess(data)))
    .then(() => handleSwitchUser(getState()))
    .then(() => dispatch(updateTermsAndConditionsState()))
    .catch((error) => {
      dispatch(authFailed(error));
      handleNetworkError(dispatch, error, () => changeProfile(profileId));
    });
};

export const authenticate = () => (dispatch) => {
  const profileId = localStorage.getItem('profileId');
  let authUrl = AuthenticationEndpoint;
  if (profileId && profileId.length > 0) {
    authUrl = `${AuthenticationEndpoint}?profileId=${profileId}`;
  }
  dispatch(authStart());
  dispatch(updateTermsAndConditionsState());

  return fetchPRS(authUrl, dispatch)
    .then((data) => {
      if (data.sam && data.sam.typeCode === 'SYSDOWN') {
        dispatch(authFailed());
        return;
      }

      if (!data.isAuthenticated) {
        localStorage.removeItem('profileId');
        // eslint-disable-next-line no-restricted-globals
        location.href = 'account/signin';
      } else {
        if (data.profiles.length) {
          localStorage.setItem('profileId', data.profiles[0].profileId);
        }
        dispatch(authSuccess(data));
        dispatch(updateTermsAndConditionsState());
      }
    })
    .catch((error) => {
      dispatch(authFailed(error));
      if (profileId && !navigator.onLine) {
        handleNetworkError(dispatch, error, authenticate);
        return;
      }
      if (error.message !== 'Network Error') {
        localStorage.removeItem('profileId');
        // eslint-disable-next-line no-restricted-globals
        location.href = 'account/signin';
      }
    });
};

export const defaultState = {
  user: null,
  authenticating: false,
};

const authenticationReducer = (
  state: Object = defaultState,
  action: Object = {},
) => {
  switch (action.type) {
    case AUTH_START:
      return Object.assign({}, state, {
        authenticating: true,
      });
    case AUTH_SUCCESS:
      return Object.assign({}, state, {
        authenticating: false,
        user: action.payload,
      });
    case AUTH_FAILURE:
      return Object.assign({}, state, {
        authenticating: false,
        error: action.payload,
      });
    case CHANGE_PROFILE:
      localStorage.setItem('profileId', action.profileId);
      return state;
    default:
      return state;
  }
};

export default authenticationReducer;
